export const US_PROVINCES = [
  { id: 'AL', description: 'Alabama' },
  { id: 'AK', description: 'Alaska' },
  { id: 'AZ', description: 'Arizona' },
  { id: 'AR', description: 'Arkansas' },
  { id: 'CA', description: 'California' },
  { id: 'CO', description: 'Colorado' },
  { id: 'CT', description: 'Connecticut' },
  { id: 'DE', description: 'Delaware' },
  { id: 'DC', description: 'District of Columbia' },
  { id: 'FL', description: 'Florida' },
  { id: 'GA', description: 'Georgia' },
  { id: 'HI', description: 'Hawaii' },
  { id: 'ID', description: 'Idaho' },
  { id: 'IL', description: 'Illinois' },
  { id: 'IN', description: 'Indiana' },
  { id: 'IA', description: 'Iowa' },
  { id: 'KS', description: 'Kansas' },
  { id: 'KY', description: 'Kentucky' },
  { id: 'LA', description: 'Louisiana' },
  { id: 'ME', description: 'Maine' },
  { id: 'MD', description: 'Maryland' },
  { id: 'MA', description: 'Massachusetts' },
  { id: 'MI', description: 'Michigan' },
  { id: 'MN', description: 'Minnesota' },
  { id: 'MS', description: 'Mississippi' },
  { id: 'MO', description: 'Missouri' },
  { id: 'MT', description: 'Montana' },
  { id: 'NE', description: 'Nebraska' },
  { id: 'NV', description: 'Nevada' },
  { id: 'NH', description: 'New Hampshire' },
  { id: 'NJ', description: 'New Jersey' },
  { id: 'NM', description: 'New Mexico' },
  { id: 'NY', description: 'New York' },
  { id: 'NC', description: 'North Carolina' },
  { id: 'ND', description: 'North Dakota' },
  { id: 'OH', description: 'Ohio' },
  { id: 'OK', description: 'Oklahoma' },
  { id: 'OR', description: 'Oregon' },
  { id: 'PA', description: 'Pennsylvania' },
  { id: 'RI', description: 'Rhode Island' },
  { id: 'SC', description: 'South Carolina' },
  { id: 'SD', description: 'South Dakota' },
  { id: 'TN', description: 'Tennessee' },
  { id: 'TX', description: 'Texas' },
  { id: 'UT', description: 'Utah' },
  { id: 'VT', description: 'Vermont' },
  { id: 'VA', description: 'Virginia' },
  { id: 'WA', description: 'Washington' },
  { id: 'WV', description: 'West Virginia' },
  { id: 'WI', description: 'Wisconsin' },
  { id: 'WY', description: 'Wyoming' }
]

export const CA_PROVINCES = [
  { id: 'AB', description: 'Alberta' },
  { id: 'BC', description: 'British Columbia' },
  { id: 'MB', description: 'Manitoba' },
  { id: 'NB', description: 'New Brunswick' },
  { id: 'NL', description: 'Newfoundland and Labrador' },
  { id: 'NT', description: 'Northwest Territories' },
  { id: 'NS', description: 'Nova Scotia' },
  { id: 'NU', description: 'Nunavut' },
  { id: 'ON', description: 'Ontario' },
  { id: 'PE', description: 'Prince Edward Island' },
  { id: 'QC', description: 'Quebec' },
  { id: 'SK', description: 'Saskatchewan' },
  { id: 'YT', description: 'Yukon' }
]
